import AssistantCitation from "ai-assistant/values/assistant-citation";
import Date from "common/values/date/date";

export enum Role {
  Assistant = "assistant",
  User = "user",
  System = "system"
}
export default class AssistantResponse {
  private readonly _responseId?: string;
  private readonly _role: Role;
  private readonly _text: string;
  private readonly _citations: AssistantCitation[] = [];
  private readonly _timestamp: Date;

  constructor(
    responseId: string | undefined, 
    role: Role, 
    text: string,
    citations: AssistantCitation[],
    timestamp: Date = new Date()
  ) {
    this._responseId = responseId;
    this._role = role;
    this._text = text;
    this._citations = citations;
    this._timestamp = timestamp;
  }

  public get responseId(): string | undefined {
    return this._responseId;
  }

  public get role(): Role {
    return this._role;
  }

  public get text(): string {
    return this._text;
  }

  public get citations(): AssistantCitation[] {
    return this._citations;
  }

  public get timestamp(): Date {
    return this._timestamp;
  }

  toString(): string {
    return `
      Response ID: ${this._responseId}, 
      Role: ${this._role}, 
      Text: ${this.text},
      Citations: ${this.citations.map(citation => citation.toString()).join(", ")},
      Timestamp: ${this._timestamp.toISOString()}
    `;
  }
}
